import React from 'react';
import './separate-box.scss';

export default function SeparateBox() {
  return (
    <div className="separate-box" />
  );
}
